var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.9999V4.3999H14V13.9999H2Z",
    fill: "#1554FF",
    stroke: "#1554FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 7.3335C10.6663 8.04074 10.3854 8.71902 9.88529 9.21911C9.3852 9.71921 8.70692 10.0002 7.99967 10.0002C7.29243 10.0002 6.61415 9.71921 6.11406 9.21911C5.61396 8.71902 5.33301 8.04074 5.33301 7.3335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 4C10.6663 3.29276 10.3854 2.61448 9.88529 2.11438C9.3852 1.61428 8.70692 1.33333 7.99967 1.33333C7.29243 1.33333 6.61415 1.61428 6.11406 2.11438C5.61396 2.61448 5.33301 3.29276 5.33301 4",
    stroke: "#1554FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductFilled);
export default __webpack_public_path__ + "static/media/productFilled.bacc95b3eeb32e4cc3a59c7216fbd568.svg";
export { ForwardRef as ReactComponent };